import { Directive, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: false,
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
  @Output() appClickOutside = new EventEmitter<MouseEvent>();

  private handler: ((event: MouseEvent) => void) | null = null;

  constructor(
    private elRef: ElementRef<HTMLElement>,
    private zone: NgZone,
  ) {}

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      const handler = (event: MouseEvent) => {
        if (this.elRef.nativeElement.contains(event.target as Node)) return;
        this.zone.run(() => this.appClickOutside.emit(event));
      };
      document.addEventListener('mousedown', handler);
      this.handler = handler;
    });
  }

  ngOnDestroy(): void {
    if (this.handler) {
      document.removeEventListener('mousedown', this.handler);
      this.handler = null;
    }
  }
}
